import React, { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import classNames from "classnames";
import { Dropdown } from "./Dropdown";
import { Portal } from "../Portal";
export const Autocomplete = ({ defaultOption, options, onSelectedItemChange, }) => {
    const [show, setShow] = useState(false);
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {});
    const [selectedOption, setSelectedOption] = useState(defaultOption);
    const toggleDropdown = (event) => {
        const target = event.target;
        if (referenceElement && !referenceElement.contains(target)) {
            setShow(false);
        }
    };
    useEffect(() => {
        document.body.addEventListener("click", toggleDropdown);
        return () => {
            document.body.removeEventListener("click", toggleDropdown);
        };
    }, [popperElement]);
    return (React.createElement("div", { className: "autocomplete" },
        React.createElement("button", { type: "button", ref: setReferenceElement, className: "btn-autocomplete-label", onClick: () => {
                setShow(!show);
            } },
            React.createElement("span", null, selectedOption.node),
            React.createElement("i", { className: classNames({
                    "icon-chevron-up": show,
                    "icon-chevron-down": !show,
                }) })),
        show ? (React.createElement(Portal, null,
            React.createElement("div", { ref: setPopperElement, style: {
                    ...styles.popper,
                    zIndex: 1,
                }, ...attributes.popper },
                React.createElement(Dropdown, { options: options, selectedItem: selectedOption, onSelectedItemChange: (option) => {
                        setSelectedOption(option.selectedItem);
                        setShow(false);
                        if (onSelectedItemChange) {
                            onSelectedItemChange(option);
                        }
                    } })))) : null));
};
